<template>
    <customModal :containersm=true :bodysm=true :footerShow=true @closeModal="closeDisModal">
        <template #title>
            <h4 class="my-0">
                {{ $t("navigations.discrepancy") }} 
            </h4>
        </template>
        <template #body>
          <div class="row">
                <div class="col-lg-12">
                    <label >{{ $t("navigations.reason") }}</label>
                    <select 
                        class="form-control" 
                        placeholder="Select reason" 
                        v-model="discrepancyReason">
                        <option value="" disabled selected>
                            {{ $t("navigations.select reason") }}
                        </option>
                        <option v-for="reason in reasonsList" :key="reason._id" :value="reason.ReasonLabel">
                            {{ reason.ReasonLabel }} 
                        </option>
                    </select>

                </div>

                <div class="col-lg-12 mt-3">
                    <label for="message">{{ $t('navigations.comments') }}</label>
                    <textarea 
                        class="form-control" 
                        v-model="comments"  
                        placeholder="Message" id="message"  
                        minlength="10" spellcheck="true">
                    </textarea>
                </div>
                 <div v-if="isSingleItem" class="col-lg-12 mt-3">
                    <label for="actualValue">{{ $t('navigations.actual value') }}</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        :value="actualValueDisplay" 
                        id="actualValue" disabled 
                    />
                </div>
                <div v-if="isSingleItem" class="col-lg-12 mt-3">
                    <label for="expectedValue">{{ $t('navigations.expected value') }}</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="expectedValue"
                        id="expectedValue"
                        placeholder="Expected value"
                    />
                </div>
          </div>  
        </template>
       <template #footer>
  <div class="d-flex justify-content-end align-items-center gap-2 mt-4">

    <!-- Add Issue Icon -->
    <!-- <div class="position-relative pb-1 me-2">
      <img
        src="../../assets/img/create.png"
        alt="Add Issue"
        class="cursor-pointer"
        style="width: 20px; height: 20px"
        @click.prevent="OpenIssue(q)"
      />

      <span class="tool-tip">
        {{ $t("navigations.raise issue") }}
      </span>
    </div> -->

    <!-- Submit Button -->
    <button
      class="btn btn-primary btn-sm py-0"
      @click="verifySourceData()"
    >
      <i class="fa fa-check me-1"></i> Submit
    </button>

  </div>

      </template>

    </customModal>
    <createCraIssue
  v-if="showcreateIssueModal"
  :studyId="selectedStudyId"
  :cravisitName="visitname"
  :crasiteCode="sitecode"
  :crasiteId="siteid"
  @close="showcreateIssueModal = false"
/>
</template>

<script src="./SDV_Discrepancymodal.js"></script>